import { createApi } from '@reduxjs/toolkit/query/react'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'
import Machine from '../../types/api/machine'
import getQuery from '../../helpers/api/get-query'
import getCustomFetchBase from '../custom-fetch-base'

export const machineBrandsApi = createApi({
    reducerPath: 'machineBrandsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['MachineBrands'],
    endpoints: builder => ({
        getMachineBrands: builder.query<Strapi<Machine>, EndpointQueryParameters | void>({
            query: getQuery('/machine-brands'),
            providesTags: ['MachineBrands'],
        }),
    }),
})

export const { useGetMachineBrandsQuery } = machineBrandsApi
